export enum PeerStatus {
    ONLINE = "Онлайн",
    OFFLINE = "Офлайн",
    DISCONNECTED = "Отключен",
    UNMONITORED = "Не отслеживается",
    NOT_CONFIGURED = "Нет конфигурации"
}
